<template>
  <page-wrap>
    <layout :isEmpty="false" :messageEmpty="L10n('select-a-part')" v-loading="isLoading">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
      </template>
      <template v-slot:tools>
        <top-panel
          v-model="employeeID"
        ></top-panel>
      </template>
      <template v-slot:content>
        <layout-scroll-content>
          <div style="display: flex; flex-direction: column; height: 100%;">
            <report-panel
              :isVisible.sync="isVisibleReport"
            >
              <template v-slot:content>
                <component :is="reportComponent" :moduleName="moduleName"></component>
              </template>
            </report-panel>
            <div class="row m-4" style="height: 100%">
              <div class="col-12 mb-3">
                <div class="d-flex justify-content-center align-items-start">
                  <h3 class="blue-text">
                    {{L10n('supplier-quote')}}
                  </h3>
                  <button
                    type="button"
                    class="btn btn-size-s"
                    style="margin-left: auto"
                    @click="createRFQ2s"
                  >
                    {{L10n('create')}}
                  </button>
                </div>
                <form-rfq-2
                  ref="form"
                  :data="dataRFQ2"
                  :model="formModel"
                  @onChangePartNumber="handleChangePartNumber"
                  @change="setFormDataRFQ2"
                />
              </div>
              <div class="col-12">
                <grid-rfq-2
                  :partNumber="partNumber"
                  :eventID="eventID"
                  :formModel="formModel"
                />
              </div>
            </div>
          </div>
        </layout-scroll-content>
      </template>
    </layout>
  </page-wrap>
</template>

<script>
import StoreModule from './StoreModule'
import { ServiceRFQ2s } from '@/services/RFQ2s'
import { getDefaultRFQID } from '@/utils/shared'

export default {
  name: 'QuickIndexRFQ2',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'top-panel': () => import(/* webpackChunkName: 'QuickRFQ2' */ './TopPanel.vue'),
    'form-rfq-2': () => import(/* webpackChunkName: 'QuickRFQ2' */ './FormRFQ2.vue'),
    'grid-rfq-2': () => import(/* webpackChunkName: 'QuickRFQ2' */ './GridRFQ2/Index.vue'),
    'reports-low': () => import(/* webpackChunkName: 'QuickRFQ2' */ './ReportsLowPermission/Index.vue'),
    'reports-high': () => import(/* webpackChunkName: 'QuickRFQ2' */ './ReportsHighPermission/Index.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'report-panel': () => import(/* webpackChunkName: 'ReportPanel' */ '@/components/UI/ReportPanel')
  },
  created () {
    const store = this.$store
    const moduleName = this.moduleName
    if (store && !store.state[moduleName]) {
      store.registerModule(moduleName, StoreModule)
    }
  },
  beforeDestroy () {
    this.$store.dispatch(`${this.moduleName}/resetState`)
  },
  data () {
    return {
      moduleName: 'quick-rfq-2',
      eventID: 'quick-rfq-2',
      isVisibleReport: false,
      // eslint-disable-next-line
      apiPatch: 'RFQ2s/Patch/${data.id}',
      partNumber: ''
    }
  },
  computed: {
    employeeID: {
      get () {
        return this.formDataRFQ2.employeeID
      },
      set (value) {
        this.$store.commit(`${this.moduleName}/MERGE`,
          { key: 'dataRFQ2', value: { ...this.formDataRFQ2, 'employeeID': value } })
      }
    },
    isHighPermission () {
      return this.$store.getters.isHighPermission
    },
    reportComponent () {
      return this.isHighPermission
        ? 'reports-high'
        : 'reports-low'
    },
    isLoading () {
      return this.$store.state[this.moduleName].isLoading
    },
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    },
    dataRFQ2 () {
      return this.$store.state[this.moduleName].dataRFQ2
    },
    formDataRFQ2 () {
      return this.$store.state[this.moduleName].formDataRFQ2
    }
  },
  methods: {
    handleChangePartNumber (partNumber) {
      this.partNumber = partNumber
    },
    getFormData () {
      return this.formDataRFQ2
    },
    formModel () {
      return {
        ...ServiceRFQ2s.getModel(),
        rfqid: getDefaultRFQID(),
        employeeID: this.$store.getters.get('currentUser').employeeID
      }
    },
    setFormDataRFQ2 (data) {
      this.$store.commit(`${this.moduleName}/SET`, { key: 'formDataRFQ2', value: data })
    },
    createRFQ2s () {
      this.$refs.form.validate()
        .then(() => {
          this.create()
        })
        .catch((err) => {
          this.validateErrorHandler(err)
        })
    },
    create () {
      this.$store.dispatch(`${this.moduleName}/createRFQ2`)
        .then(() => {
          this.$bus.$emit(`on-created-${this.eventID}`)
        })
    }
  }
}
</script>

<style lang="stylus">
  .quick-rfq__step{
    margin-bottom 2rem
  }
  .info-section{
    color #65646c
    font-size 1.4rem
    margin-bottom 1rem
  }
  .info-section__title{
    font-weight bold
    text-transform capitalize
  }
  .info-section_head{
    background-color #f2fbfe
    text-align center
    margin 0 0 1rem
    padding .5rem 0
  }
</style>
